import translations from './const/ru.json';
export default {
  translation: { ...translations }
};